import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { Header } from '../components/Header'
import { SettingsForm } from '../features/settings/SettingsForm'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const SettingsPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Header title={t('settings.title.title')} />

      <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
        <SettingsForm />
      </ErrorBoundary>
    </>
  )
}
